<template>
  <div class="bto-sb-widget bto-sb-widget-banner" v-if="showBanner">
    <component :is="link.component" v-bind="link.props">
      <img :src="link.imgUrl ? link.imgUrl : defaultImg" />
    </component>
  </div>
</template>

<script>
  import { getLinkProps } from '@bto-services/quick-links';

  export default {
    name: 'ImageBannerWidget',
    data() {
      return {
        defaultImg: `${APP_SETTINGS.path.appUrl}images/banner-m.jpg`,
        showBanner: true,
      };
    },
    props: {
      image: {
        fieldType: 'string',
        default: '',
        label: 'Image src'
      },
      href: {
        fieldType: 'string',
        default: '',
        label: 'Link to'
      },
      locale: {
        fieldType: 'string',
        default: '',
        label: 'language (locale)'
      },
      target: {
        fieldType: 'array',
        default: () => [{ val: '_self', label: 'Same Tab' }, { val: '_blank', label: 'New Tab' }],
        selectedVal: '_blank',
        label: 'Target'
      },
    },
    computed: {
      link() {
        return getLinkProps({ iconUrl: this.image, link: this.href, target: this.target, label: '' });
      },
    },
    created() {
      this.showBanner = this.locale === '' || this.locale === APP_SETTINGS.player.language;
    },
  };
</script>
